<script lang="ts">
import FilterButton from '@/components/FilterButton.vue';

export default {
  name: 'WholesalerGroupFilter',
  components: { FilterButton },
};
</script>

<script lang="ts" setup>
import { ref, computed, watch } from 'vue';
import { WholesalerGroup } from '@/types/WholesalerGroup';

const props = defineProps<{
  wholesalers: WholesalerGroup[];
}>();

const selected = defineModel<WholesalerGroup[]>('selected', { required: true });

const emit = defineEmits(['updated']);

const dirty = ref(false);

const title = computed(() => {
  return selected?.value.length === 1 ? selected.value[0].name : 'Wholesaler Group';
});

const clear = () => {
  selected.value = [];
};

const save = () => {
  if (dirty.value) {
    dirty.value = false;
    emit('updated');
  }
  return true;
};

const selectAll = () => {
  selected.value = [...props.wholesalers];
};

watch(selected, () => {
  dirty.value = true;
});
</script>

<template>
  <FilterButton :title="title" @close="save" :active="selected.length > 0" data-testid="wholesaler-group-filter">
    <template #menu="{ close }">
      <div class="tw:min-w-[500px] tw:pt-4">
        <h4 class="tw:px-4">All Wholesaler Groups</h4>
        <div class="tw:mt-2 tw:grid tw:max-h-[300px] tw:grid-cols-2 tw:overflow-y-scroll tw:p-2 tw:px-4">
          <label
            v-for="item in wholesalers"
            :key="item.id"
            class="tw:grid tw:cursor-pointer tw:select-none tw:grid-cols-[auto_1fr] tw:items-center tw:gap-2 tw:py-1">
            <input
              type="checkbox"
              v-model="selected"
              :value="item"
              data-testid="filter-item-wholesaler-group-checkbox" />
            <span>{{ item.name }}</span>
          </label>
        </div>
        <div class="tw:border-v-border-base tw:bg-v-gray-lighten5 tw:flex tw:justify-between tw:border-t tw:p-4">
          <v-btn size="small" variant="outlined" @click="clear" data-testid="filter-wholesaler-group-clear"
            >Clear
          </v-btn>
          <span>
            <v-btn
              class="tw:mr-2"
              variant="flat"
              size="small"
              color="secondary"
              @click="selectAll"
              data-testid="filter-wholesaler-group-select-all"
              >Select All</v-btn
            >
            <v-btn
              size="small"
              variant="flat"
              color="primary"
              @click="close"
              data-testid="filter-wholesaler-group-apply"
              >Apply</v-btn
            >
          </span>
        </div>
      </div>
    </template>
  </FilterButton>
</template>
